import CalendarComparisonPage from './CalendarComparisonPage';

export default CalendarComparisonPage;
